import CustomModal from "@UI/CustomModal"
import PropTypes from "prop-types"
import './styles.css'
import { Button, Form } from "antd"
import { CustomInput } from "@UI/CustomInput"
import { ReactComponent as InfoIcon } from '@pages/collectionAdministration/pages/NewEditTemplateCollection/components/NewEditTemplateCollectionBody/components/NewEditTemplateCollectionBodyOptions/assets/infoTooltipIcon.svg'
import CustomPopoverConfirm from "@UI/CustomPopoverConfirm"
import { useArrearsModal } from "./hooks/useArrearsModal"

const ArrearsModal = ({
  isOpenModal,
  handleOpenCloseModal
}) => {
  const {
    form,
    isSingleCode,
    buttonsArrearsOptions,
    currencySymbol,
    handleSaveRecurrence,
    handleChangeRecurrenceMethod
  } = useArrearsModal({ handleOpenCloseModal, isOpenModal })

  return (
    <CustomModal
      destroyOnClose={true}
      className="custom-modal"
      isOpenModal={isOpenModal}
      onCancel={() => {
        handleOpenCloseModal({ isOpenModal: false })
        form.resetFields()
      }}
      width={450}
    >
      <div className="arrears-modal-title">
        <span>Mora</span>
        <CustomPopoverConfirm
          placement={'bottom'}
          overlayClassName={'info-tooltip-popover'}
          content={<div className="info-tooltip-popover-content">
            <p>Define el monto de mora que se aplicará si el pago se realiza después de la fecha límite:</p>
            <p>Porcentaje: Se calcula un porcentaje sobre el saldo adeudado.</p>
            <p>Cantidad fija: Se aplica un monto específico sin importar el saldo pendiente.</p>
          </div>}
          maxWidth={325}
        >
          <Button icon={<InfoIcon />} className="btn-standard-transparent" shape="circle" style={{ marginLeft: '8px', width: '32px' }} />
        </CustomPopoverConfirm>
      </div>
      <div className="arrears-modal-options">
        {
          buttonsArrearsOptions.map((item, index) => ({ ...item, key: index })).map((item) => (
            <Button
              key={item.key}
              className={item.code === isSingleCode ? 'btn-standard-green' : 'btn-standard-white'}
              shape="round" style={{ width: '150px' }}
              onClick={() => handleChangeRecurrenceMethod({ code: item.code, value: item.id })}>
              {item.name}
            </Button>
          ))
        }
      </div>
      <Form
        className="arrears-modal-form"
        form={form}
        layout="vertical"
        onFinish={(values) => handleSaveRecurrence({ values })}
      >
        <Form.Item
          name="charge_late_fee_type_id"
          rules={[{ required: true, message: 'El campo es necesario' }]}
          noStyle
        />
        <Form.Item
          label={isSingleCode === 'percentage' ? 'Porcentaje' : 'Cantidad fija'}
          name="value"
          rules={[{ required: true, message: 'El campo es necesario' }]}
        >
          <CustomInput
            type="NUMBER"
            step={0.01}
            min={1}            
            precision={2}
            className="amount-arrears-modal custom-input"
            max={isSingleCode === 'percentage' ? 100 : null}
            prefix={isSingleCode === 'percentage' ? '%' : currencySymbol}
            placeholder={'Escribir cantidad'}
            nullInputNumberText={null}
          />
        </Form.Item>
        <div className="arrears-modal-form-footer">
          <Button htmlType="submit" className="btn-standard-green" shape="round" style={{ width: '133px' }}>
            GUARDAR
          </Button>
        </div>
      </Form>
    </CustomModal>
  )
}

ArrearsModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  handleOpenCloseModal: PropTypes.func.isRequired
}

export default ArrearsModal
